import { View, Text } from "@react-pdf/renderer";

import { styles } from "../styles";

export function Footer({ facilityName }: { facilityName: string | undefined }) {
  return (
    <View style={{ ...styles.section, paddingBottom: "0px" }} fixed>
      <View style={{ ...styles.centralizeView, flexDirection: "column" }}>
        <Text
          render={({ pageNumber, totalPages }) =>
            `${facilityName} | Page ${pageNumber} of ${totalPages}`
          }
          fixed
          style={{
            fontSize: 10,
          }}
        />
        <Text
          style={{
            fontSize: 8,
            marginTop: 2,
            color: "#666",
          }}
        >
          www.clearhealthinc.com | 888-918-2522 | support@clearhealthinc.com |
          Clear Health Inc. All rights reserved.
        </Text>
      </View>
    </View>
  );
}
